import { ImportedDataProvider } from './ImportedData.provider';
import { ImportedDataService } from './ImportedData.service';
import { ImportedDataRequestService } from './ImportedDataRequest.service';

const DEFAULT_MAX_RETRIES = 3;
const DEFAULT_CACHE_DURATION = 60 * 60; // 1 hour

export type ImportedDataProviderFactoryConfig = {
  cacheDuration: number;
  maxRetries: number;
};

export class ImportedDataProviderFactory {
  static defaultCacheDuration(): number {
    return !!process?.env?.IMPORTED_DATA_CACHE_DURATION
      ? +process.env.IMPORTED_DATA_CACHE_DURATION
      : DEFAULT_CACHE_DURATION;
  }
  static defaultMaxRetries(): number {
    return !!process?.env?.IMPORTED_DATA_MAX_RETRIES
      ? +process.env.IMPORTED_DATA_MAX_RETRIES
      : DEFAULT_MAX_RETRIES;
  }

  static create(config?: ImportedDataProviderFactoryConfig): ImportedDataProvider {
    const cacheDuration: number = !!config?.cacheDuration
      ? config.cacheDuration
      : ImportedDataProviderFactory.defaultCacheDuration();
    const maxRetries: number = !!config?.maxRetries
      ? config.maxRetries
      : ImportedDataProviderFactory.defaultMaxRetries();

    const service = new ImportedDataService(maxRetries);
    const requestService = new ImportedDataRequestService(maxRetries);
    return new ImportedDataProvider(service, cacheDuration, requestService);
  }
}
